const bind = function (form) {
    $('form').find('.on-change-submit, [data-on-change-submit]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });
}

export {
    bind,
}
